import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "../data/tour";
import { SectionHead, Reveal } from "./Reveal";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10">
    <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <SectionHead index="05" overline="Before You Pack" title="Questions, answered straight." />
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-sage">
            Anything else on your mind? The fastest way to reach a real human on our team is
            WhatsApp — 95297 17726.
          </p>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion type="single" collapsible data-testid="faq-accordion" className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-vine">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="text-left hover:no-underline"
              >
                <span className="flex items-baseline gap-5">
                  <span className="font-sans text-xs font-bold tracking-[0.25em] text-marigold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-serif text-xl font-medium text-cream">{f.q}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="text-sm leading-relaxed text-sage">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
